import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%","height":"100%"} }

import { ref } from 'vue'
import { useRoute } from 'vue-router'
import MainMenu from '@/layout/menu/MainMenu.vue'
import SubMenu from '@/layout/menu/SubMenu.vue'
import FarmaciFooter from '@/layout/components/FarmaciFooter.vue'
import { MenuItemModel } from '@/../../EshJSLib/models/MenuItemModel';
import PrivacyPolicy from '@/layout/menu/PrivacyPolicy.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const submenu = ref<MenuItemModel>();


function onToggleMenu(item: MenuItemModel) {
  submenu.value = item;
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(route).name !=='Login')
      ? (_openBlock(), _createBlock(MainMenu, {
          key: 0,
          onToggleSubmenu: onToggleMenu
        }))
      : _createCommentVNode("", true),
    (_unref(route).name !=='Login' && _unref(route).name !=='Account')
      ? (_openBlock(), _createBlock(SubMenu, {
          key: 1,
          subitems: submenu.value
        }, null, 8, ["subitems"]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, { class: "container_esh" }),
    (_unref(route).path =='/Registro/Farmaci')
      ? (_openBlock(), _createBlock(FarmaciFooter, { key: 2 }))
      : _createCommentVNode("", true),
    (_unref(route).path !=='/login')
      ? (_openBlock(), _createBlock(PrivacyPolicy, { key: 3 }))
      : _createCommentVNode("", true)
  ]))
}
}

})